import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useGetDashboardGraphs, useGetDashboardRecent } from "../../hooks";
import {
  RecentCustomersTable,
  RecentLaborTable,
  RecentOrdersTable,
  RecentPartsTable,
  RecentShipmentsTable,
  RecentWorkOrdersTable,
} from "../../tables";

import DashboardCard from "./DashboardCard";
import DashboardLaborChart from "./DashboardLaborChart";
import DashboardRevenueChart from "./DashboardRevenueChart";
import DashboardThroughputChart from "./DashboardThroughputChart";
import { StyledCardGrid } from "./styles";

const DashboardPageContent = ({ filters = {}, period = "1Q" }) => {
  const { search } = useLocation();

  const {
    data: recent = {},
    isLoading,
    refetch,
  } = useGetDashboardRecent({ ...filters, period });

  const { data: graphs = {}, isLoading: isGraphsLoading } =
    useGetDashboardGraphs({ ...filters, period });

  useEffect(() => {
    refetch();
  }, [search?.toString()]);

  return (
    <StyledCardGrid>
      <DashboardCard title="Work Order Throughput">
        <DashboardThroughputChart
          buckets={graphs.workOrders || []}
          groupBy={graphs.groupBy}
          isLoading={isGraphsLoading}
        />
      </DashboardCard>
      <DashboardCard title="Recent Work Orders">
        <RecentWorkOrdersTable rows={recent.workOrders} isLoading={isLoading} />
      </DashboardCard>

      <DashboardCard title="Orders Created">
        <DashboardRevenueChart
          series={graphs.orders || []}
          isLoading={isGraphsLoading}
          color="#16a34a"
          emptyIcon="ShoppingCart"
          emptyTitle="No orders revenue"
        />
      </DashboardCard>
      <DashboardCard title="Recent Orders">
        <RecentOrdersTable rows={recent.orders} isLoading={isLoading} />
      </DashboardCard>

      <DashboardCard title="Shipment Created">
        <DashboardRevenueChart
          series={graphs.shipments || []}
          isLoading={isGraphsLoading}
          color="#6f5af0"
          emptyIcon="Archive"
          emptyTitle="No shipment revenue"
        />
      </DashboardCard>
      <DashboardCard title="Recent Shipments">
        <RecentShipmentsTable rows={recent.shipments} isLoading={isLoading} />
      </DashboardCard>

      <DashboardCard title="Labor Tickets by Department">
        <DashboardLaborChart data={graphs.labor} isLoading={isGraphsLoading} />
      </DashboardCard>
      <DashboardCard title="Recent Labor by Department">
        <RecentLaborTable rows={recent.labor} isLoading={isLoading} />
      </DashboardCard>

      <DashboardCard title="Recent Parts">
        <RecentPartsTable rows={recent.parts} isLoading={isLoading} />
      </DashboardCard>
      <DashboardCard title="Recent Customers">
        <RecentCustomersTable rows={recent.customers} isLoading={isLoading} />
      </DashboardCard>
    </StyledCardGrid>
  );
};

export default DashboardPageContent;
